module.exports = __webpack_public_path__ + "img/konging.db66406b.png";